import { postMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin, getUserRole } from 'utils/general';

// Action Types
export const ADD_SUB_CATEGORY = 'ADD_SUB_CATEGORY';
export const ADD_SUB_CATEGORY_SUCCESS = 'ADD_SUB_CATEGORY_SUCCESS';
export const ADD_SUB_CATEGORY_FAILURE = 'ADD_SUB_CATEGORY_FAILURE';

// Action Creators
export const fetchAddSubCategory = () => ({
  type: ADD_SUB_CATEGORY,
});

export const fetchAddSubCategorySuccess = (data) => ({
  type: ADD_SUB_CATEGORY_SUCCESS,
  payload: data,
});

export const fetchAddSubCategoryFailure = (error) => ({
  type: ADD_SUB_CATEGORY_FAILURE,
  payload: error,
});

// Thunk Function
export const addSubCategoryCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchAddSubCategory(data, external));
    try {
      const userRole = getUserRole();
      const response = await postMethodWithToken(
        userRole === 'super-admin'
          ? url.addSubCategoryListSuperAdmin
          : url.addSubCategoryServiceProviderAdmin,
        data
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchAddSubCategorySuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchAddSubCategoryFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchAddSubCategoryFailure(error.message));
    }
  };
};
